// Import model
import { FilterOtgCatalogManufacturerRequest } from '../models/FilterOtgCatalogManufacturerRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { OtgCatalogManufacturerCondition } from '../models/OtgCatalogManufacturerCondition';
import { OtgCatalogManufacturerFields } from '../models/OtgCatalogManufacturerFields';
import { OtgCatalogManufacturerIndexedFields } from '../models/OtgCatalogManufacturerIndexedFields';

// Import dependency serializers (for complex types)
import { OtgCatalogManufacturerConditionSerializer } from './OtgCatalogManufacturerConditionSerializer';
import { OtgCatalogManufacturerFieldsSerializer } from './OtgCatalogManufacturerFieldsSerializer';
import { OtgCatalogManufacturerIndexedFieldsSerializer } from './OtgCatalogManufacturerIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterOtgCatalogManufacturerRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterOtgCatalogManufacturerRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterOtgCatalogManufacturerRequest instance
   */
  static deserialize(json: string): FilterOtgCatalogManufacturerRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterOtgCatalogManufacturerRequest instance
   */
  static fromObject(obj: any): FilterOtgCatalogManufacturerRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterOtgCatalogManufacturerRequest');
    }


    const instance: FilterOtgCatalogManufacturerRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as OtgCatalogManufacturerIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as OtgCatalogManufacturerFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        OtgCatalogManufacturerConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterOtgCatalogManufacturerRequest instances
   */
  static deserializeArray(json: string): FilterOtgCatalogManufacturerRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterOtgCatalogManufacturerRequest instance to a JSON string
   */
  static serialize(instance: FilterOtgCatalogManufacturerRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterOtgCatalogManufacturerRequest instance to a plain object
   */
  static toObject(instance: FilterOtgCatalogManufacturerRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        OtgCatalogManufacturerConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterOtgCatalogManufacturerRequest instances to a JSON string
   */
  static serializeArray(instances: FilterOtgCatalogManufacturerRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
